import { api } from "../Configurations/axios";

//Get:
const GetAllYearsInRecommendation = async (companyId: string) => {
    try {
        const result = await api.get(`/Recommendation/GetAllYears/?companyId=${companyId}`);
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const GetAllFavLinesByCompanyIdAPI = async (companyId: string, page: number, take: number, word: string) => {
    try {
        const result = await api.get(`/Recommendation/GetAllFavLinesByCompanyId/?companyId=${companyId}&page=${page}&take=${take}&word=${encodeURIComponent(word)}`);
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const GetAllProjectLinesByCompanyIdAPI = async (companyId: string, page: number, take: number, word: string) => {
    try {
        const result = await api.get(`/Recommendation/GetAllProjectLinesByCompanyId/?companyId=${companyId}&page=${page}&take=${take}&word=${encodeURIComponent(word)}`);
        const response = await result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const GetAllProjectGroupingLinesByCompanyIdAPI = async (companyId: string, page: number, take: number, word: string) => {
    try {
        const result = await api.get(`/Recommendation/GetAllProjectGroupingLinesByCompanyId/?companyId=${companyId}&page=${page}&take=${take}&word=${encodeURIComponent(word)}`);
        const response = await result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const GetAllAssignedLinesByProjectIdAPI = async (projectId: string, page: number, take: number, word: string) => {
    try {
        const result = await api.get(`/Recommendation/GetAllFavLinesByProjectId/?projectId=${projectId}&page=${page}&take=${take}&word=${encodeURIComponent(word)}`);
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const GetAllNotAssignedLinesByProjectIdAPI = async (projectId: string, companyId: string, page: number, take: number, word: string) => {
    try {
        const result = await api.get(`/Recommendation/GetAllFavLinesNotAssignedByProjectId/?projectId=${projectId}&companyId=${companyId}&page=${page}&take=${take}&word=${encodeURIComponent(word)}`);
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}
const GetAllLinesNotAssignedByProjectGroupingIdAPI = async (projectGroupingId: string, companyId: string, page: number, take: number, word: string) => {
    try {
        const result = await api.get(`/Recommendation/GetAllLinesNotAssignedByProjectGroupingId/?projectGroupingId=${projectGroupingId}&companyId=${companyId}&page=${page}&take=${take}&word=${encodeURIComponent(word)}`);
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const GetQtdProjAndLinesAPI = async (companyId: string) => {
    try {
        const result = await api.get(`/Recommendation/GetQtdLinesAndProjByCompanyId/?companyId=${companyId}`);
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const GetAllAssignedProjectByLineIdAPI = async (lineId: string, page: number, take: number, word: string) => {
    try {
        const result = await api.get(`/Recommendation/GetAllProjectsByLineId/?lineId=${lineId}&page=${page}&take=${take}&word=${encodeURIComponent(word)}`);
        const response = await result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}
const GetAllProjectGroupingByLineIdAPI = async (lineId: string, page: number, take: number, word: string) => {
    try {
        const result = await api.get(`/Recommendation/GetAllProjectGroupingByLineId/?lineId=${lineId}&page=${page}&take=${take}&word=${encodeURIComponent(word)}`);
        const response = await result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const GetLineById = async (lineId: string) => {
    try {
        const result = await api.get(`/Recommendation/GetLineById/?lineId=${lineId}`);
        const response = await result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const GetAllProjectsAndProjectsLinesByProjectGroupingAPI = async (projectGroupingId: string, page: number, take: number, word: string) => {
    try {
        const result = await api.get(`/Recommendation/GetAllProjectsAndProjectsLinesByProjectGrouping/?projectGroupingId=${projectGroupingId}&page=${page}&take=${take}&word=${encodeURIComponent(word)}`);
        const response = await result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const GetAllProjectsPaginatedByGroupingIdAPI = async (projectGroupingId: string, year: number, page: number, take: number, word: string) => {
    try {
        var result = await api.get(`/Recommendation/GetAllProjectsPaginatedByGroupingId/?projectGroupingId=${projectGroupingId}&year=${year}&page=${page}&take=${take}&word=${encodeURIComponent(word)}`);
        var response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}
const GetAllProjectLinesPaginatedByGroupingIdAPI = async (projectGroupingId: string, page: number, take: number, word: string) => {
    try {
        var result = await api.get(`/Recommendation/GetAllProjectLinesPaginatedByGroupingId/?projectGroupingId=${projectGroupingId}&page=${page}&take=${take}&word=${encodeURIComponent(word)}`);
        var response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const GetProjectAndLinesCountByProjectGroupingAPI = async(projectGroupingId: string) =>{
    try {
        var result = await api.get(`/Recommendation/GetProjectAndLinesCountByProjectGrouping/?projectGroupingId=${projectGroupingId}`);
        var response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

//Post
const CreateProjectLinesAPI = async (projectId: string, userEmail: string, linesIds: string[], companyId: string) => {
    try {
        const result = await api.post('/Recommendation/CreateProjectLines', {
            projectId: projectId,
            userEmail: userEmail,
            linesIds: linesIds,
            companyId: companyId
        });
        const response = await result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}
const CreateProjectGroupingLinesAPI = async (projectGroupingId: string, userEmail: string, linesIds: string[], companyId: string) => {
    try {
        const result = await api.post('/Recommendation/CreateProjectGroupingLines', {
            projectGroupingId: projectGroupingId,
            userEmail: userEmail,
            linesIds: linesIds,
            companyId: companyId
        });
        const response = await result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}
//Delete
const DeleteProjectLinesAPI = async (projectId: string, lineId: string, companyId: string) => {
    try {
        const result = await api.delete('/Recommendation/DeleteProjectLines', { data: {
            projectId: projectId,
            lineId: lineId,
            companyId: companyId
        }});
        const response = await result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const DeleteProjectGroupingLinesAPI = async (projectGroupingId: string, lineId: string, companyId: string) => {
    try {
        const result = await api.delete('/Recommendation/DeleteProjectGroupingLines', { data: {
            projectGroupingId: projectGroupingId,
            lineId: lineId,
            companyId: companyId
        }});
        const response = await result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

export {
    GetAllYearsInRecommendation,
    GetAllAssignedLinesByProjectIdAPI,
    GetAllFavLinesByCompanyIdAPI,
    GetAllNotAssignedLinesByProjectIdAPI,
    GetAllLinesNotAssignedByProjectGroupingIdAPI,
    GetQtdProjAndLinesAPI,
    GetAllAssignedProjectByLineIdAPI,
    GetAllProjectGroupingByLineIdAPI,
    GetAllProjectLinesByCompanyIdAPI,
    GetAllProjectGroupingLinesByCompanyIdAPI,
    GetLineById,
    GetAllProjectsAndProjectsLinesByProjectGroupingAPI,
    GetAllProjectsPaginatedByGroupingIdAPI,
    GetAllProjectLinesPaginatedByGroupingIdAPI,
    GetProjectAndLinesCountByProjectGroupingAPI,
    CreateProjectLinesAPI,
    CreateProjectGroupingLinesAPI,
    DeleteProjectLinesAPI,
    DeleteProjectGroupingLinesAPI
}